import { styled } from '@mui/material/styles';
const PercentDeliver = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.up('sm')]: {
    width: 300
  }
}));

export default PercentDeliver;
